import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      createElementVNode("path", { d: "M.75 12a11.25 11.25 0 1 0 22.5 0 11.25 11.25 0 1 0-22.5 0" }),
      createElementVNode("path", { d: "M9.88 23.05c-1.57-2.2-2.63-6.33-2.63-11S8.31 3.15 9.88 1m4.24 22.05c1.57-2.2 2.63-6.33 2.63-11S15.69 3.15 14.12 1M.75 12h22.5m-21.2 5.25h19.9M2.05 6.75h19.9" })
    ], -1)
  ]));
}
const computerDeviceNetworkLanWww = { render };
export {
  computerDeviceNetworkLanWww as default,
  render
};
//# sourceMappingURL=computer-device-network-lan-www.svg.js.map
